import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { STREAK_EVENT } from './CleanTimer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/chores/timer-streak`;

export default function CleanStreak() {
  const [s, setS] = useState(null);
  useEffect(() => {
    axios.get(API, { withCredentials: true }).then((r) => setS(r.data)).catch(() => {});
    const on = (e) => setS(e.detail);
    window.addEventListener(STREAK_EVENT, on);
    return () => window.removeEventListener(STREAK_EVENT, on);
  }, []);
  if (!s || (!s.streak && !s.best)) return null;
  const title = s.badges.map((b) => `${b.emoji} ${b.days} dagar${b.earned ? ' ✓' : ''}`).join(' · ');
  return (
    <span className="inline-flex items-center gap-1 text-xs font-black rounded-full px-2.5 py-1 bg-[#FFF0B3] border-2 border-[#E0B800]" title={title} data-testid="clean-streak">
      🔥 <span data-testid="clean-streak-count">{s.streak}</span> {s.streak === 1 ? 'dag' : 'dagar'} i rad
      {s.badges.filter((b) => b.earned).map((b) => <span key={b.days} data-testid={`clean-streak-badge-${b.days}`}>{b.emoji}</span>)}
      {!s.today_done && s.streak > 0 && <span className="font-bold opacity-70">· städa idag så håller den!</span>}
    </span>
  );
}
